import React from 'react';
import { Col, Layout, Row } from 'antd';
import AppHeader from '../shared/appHeader/AppHeader';

const { Content } = Layout;

type Props = {
    children: any;
};

const AdminLayout: React.FC<Props> = ({ children }: Props) => {
  
    return (
        <>
        <Layout>
            <AppHeader></AppHeader>
            <Content>
                <Row justify="center" className='mx-3'>
                    <Col xs={24} md={24} lg={24} >
                        {children}
                    </Col>
                </Row>
            </Content>
        </Layout>
        </>
    );
};

export default AdminLayout;
